const ITEMS = [
    "Independent clinic",
    "Hands-on therapy",
    "412 Elm Street",
    "No referral required",
    "Direct-billing extended health",
    "Seen within 7 days",
];

const Row = () => (
    <div className="flex shrink-0 items-center gap-12 pr-12">
        {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center gap-12">
                <span className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-mutedink">
                    {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-ochre" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="marquee-ticker"
        className="overflow-hidden border-y border-line bg-sand py-5"
        aria-hidden="true"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row />
        </div>
    </div>
);
